import { ref } from 'vue';
import { IssueLegacy } from '@/ui/pages/checklist/adaptors/IssueAdaptors';
import { SelectOptions } from '@/ui/types';

export const activeIssueEditable = ref<IssueLegacy | null>(null);
export const userOptions = ref<SelectOptions>([]);
